(function initGrvlEventMap() {
  "use strict";

  const VIEWBOX_WIDTH = 900;
  const VIEWBOX_HEIGHT = 1000;
  const MIN_ZOOM = 1;
  const INITIAL_ZOOM = 1.7;
  const INITIAL_CENTER = [137.2, 37.4];
  // A national map needs a high ceiling to separate venues only a few hundred metres apart.
  // Cluster clicks zoom in stages, so users do not jump directly from Japan to street level.
  const MAX_ZOOM = 2048;
  const CLUSTER_DISTANCE = 30;
  // Manual zoom switches every regional cluster to its venue pins at once.
  // Keep this separate from the click-to-fit logic so the threshold is easy to tune.
  const MANUAL_REGIONAL_EXPAND_ZOOM = 3.2;
  const PAN_PADDING = 90;
  const TOOLTIP_GAP = 22;
  const TOOLTIP_EDGE = 12;
  const HOVER_CLOSE_DELAY = 110;

  // Prototype data only. Production data should keep latitude/longitude,
  // so editors never need to estimate SVG x/y coordinates by eye.
  const UNUSED_SAMPLE_DATA = [
    {
      venueId: "sample-01",
      venueName: "SALOMON STORE SAPPORO",
      area: "HOKKAIDO",
      latitude: 43.0618,
      longitude: 141.3545,
      events: [{ date: "2026-09-20", title: "", url: "" }]
    },
    {
      venueId: "sample-02",
      venueName: "SENDAI SAMPLE VENUE",
      area: "MIYAGI",
      latitude: 38.2682,
      longitude: 140.8694,
      events: [{ date: "2026-10-04", title: "", url: "#sample-sendai" }]
    },
    {
      venueId: "sample-03",
      venueName: "SALOMON STORE SHIBUYA",
      area: "TOKYO",
      latitude: 35.6595,
      longitude: 139.7005,
      events: [
        { date: "2026-10-11", title: "", url: "#sample-tokyo-1" },
        { date: "2026-11-08", title: "", url: "#sample-tokyo-2" }
      ]
    },
    {
      venueId: "sample-04",
      venueName: "YOKOHAMA SAMPLE VENUE",
      area: "KANAGAWA",
      latitude: 35.4437,
      longitude: 139.638,
      events: [{ date: "2026-10-18", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-03",
      venueName: "SHINJUKU SAMPLE VENUE",
      area: "TOKYO",
      latitude: 35.6938,
      longitude: 139.7034,
      events: [{ date: "2026-10-19", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-04",
      venueName: "KICHIJOJI SAMPLE VENUE",
      area: "TOKYO",
      latitude: 35.7033,
      longitude: 139.5797,
      events: [{ date: "2026-10-20", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-05",
      venueName: "TACHIKAWA SAMPLE VENUE",
      area: "TOKYO",
      latitude: 35.6982,
      longitude: 139.4137,
      events: [{ date: "2026-10-21", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-06",
      venueName: "MACHIDA SAMPLE VENUE",
      area: "TOKYO",
      latitude: 35.5428,
      longitude: 139.445,
      events: [{ date: "2026-10-22", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-07",
      venueName: "OMIYA SAMPLE VENUE",
      area: "SAITAMA",
      latitude: 35.9063,
      longitude: 139.6239,
      events: [{ date: "2026-10-23", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-08",
      venueName: "KAWAGOE SAMPLE VENUE",
      area: "SAITAMA",
      latitude: 35.9251,
      longitude: 139.4858,
      events: [{ date: "2026-10-24", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-09",
      venueName: "KASHIWA SAMPLE VENUE",
      area: "CHIBA",
      latitude: 35.8622,
      longitude: 139.9709,
      events: [{ date: "2026-10-25", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-10",
      venueName: "CHIBA SAMPLE VENUE",
      area: "CHIBA",
      latitude: 35.6074,
      longitude: 140.1065,
      events: [{ date: "2026-10-26", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-11",
      venueName: "URAYASU SAMPLE VENUE",
      area: "CHIBA",
      latitude: 35.6539,
      longitude: 139.9022,
      events: [{ date: "2026-10-27", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-12",
      venueName: "KAWASAKI SAMPLE VENUE",
      area: "KANAGAWA",
      latitude: 35.5308,
      longitude: 139.7029,
      events: [{ date: "2026-10-28", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-13",
      venueName: "FUJISAWA SAMPLE VENUE",
      area: "KANAGAWA",
      latitude: 35.3387,
      longitude: 139.4875,
      events: [{ date: "2026-10-29", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-14",
      venueName: "TSUKUBA SAMPLE VENUE",
      area: "IBARAKI",
      latitude: 36.0835,
      longitude: 140.0764,
      events: [{ date: "2026-10-30", title: "", url: "" }]
    },
    {
      venueId: "sample-tokyo-15",
      venueName: "UTSUNOMIYA SAMPLE VENUE",
      area: "TOCHIGI",
      latitude: 36.5551,
      longitude: 139.8828,
      events: [{ date: "2026-10-31", title: "", url: "" }]
    },
    {
      venueId: "sample-05",
      venueName: "NAGOYA SAMPLE VENUE",
      area: "AICHI",
      latitude: 35.1815,
      longitude: 136.9066,
      events: [{ date: "2026-10-25", title: "", url: "#sample-nagoya" }]
    },
    {
      venueId: "sample-06",
      venueName: "OSAKA SAMPLE VENUE",
      area: "OSAKA",
      latitude: 34.6937,
      longitude: 135.5023,
      events: [{ date: "2026-11-01", title: "", url: "#sample-osaka" }]
    },
    {
      venueId: "sample-07",
      venueName: "KOBE SAMPLE VENUE",
      area: "HYOGO",
      latitude: 34.6901,
      longitude: 135.1955,
      events: [{ date: "2026-11-03", title: "", url: "" }]
    },
    {
      venueId: "sample-kansai-03",
      venueName: "KYOTO SAMPLE VENUE",
      area: "KYOTO",
      latitude: 35.0116,
      longitude: 135.7681,
      events: [{ date: "2026-11-04", title: "", url: "" }]
    },
    {
      venueId: "sample-kansai-04",
      venueName: "ARASHIYAMA SAMPLE VENUE",
      area: "KYOTO",
      latitude: 35.0094,
      longitude: 135.6668,
      events: [{ date: "2026-11-05", title: "", url: "" }]
    },
    {
      venueId: "sample-kansai-05",
      venueName: "TAKATSUKI SAMPLE VENUE",
      area: "OSAKA",
      latitude: 34.8461,
      longitude: 135.6173,
      events: [{ date: "2026-11-06", title: "", url: "" }]
    },
    {
      venueId: "sample-kansai-06",
      venueName: "SUITA SAMPLE VENUE",
      area: "OSAKA",
      latitude: 34.7595,
      longitude: 135.5169,
      events: [{ date: "2026-11-07", title: "", url: "" }]
    },
    {
      venueId: "sample-kansai-07",
      venueName: "SAKAI SAMPLE VENUE",
      area: "OSAKA",
      latitude: 34.5733,
      longitude: 135.4831,
      events: [{ date: "2026-11-08", title: "", url: "" }]
    },
    {
      venueId: "sample-kansai-08",
      venueName: "HIRAKATA SAMPLE VENUE",
      area: "OSAKA",
      latitude: 34.8143,
      longitude: 135.6507,
      events: [{ date: "2026-11-09", title: "", url: "" }]
    },
    {
      venueId: "sample-kansai-09",
      venueName: "NARA SAMPLE VENUE",
      area: "NARA",
      latitude: 34.6851,
      longitude: 135.8048,
      events: [{ date: "2026-11-10", title: "", url: "" }]
    },
    {
      venueId: "sample-kansai-10",
      venueName: "NISHINOMIYA SAMPLE VENUE",
      area: "HYOGO",
      latitude: 34.7376,
      longitude: 135.3416,
      events: [{ date: "2026-11-11", title: "", url: "" }]
    },
    {
      venueId: "sample-08",
      venueName: "HIROSHIMA SAMPLE VENUE",
      area: "HIROSHIMA",
      latitude: 34.3853,
      longitude: 132.4553,
      events: [{ date: "2026-11-15", title: "", url: "#sample-hiroshima" }]
    },
    {
      venueId: "sample-09",
      venueName: "FUKUOKA SAMPLE VENUE",
      area: "FUKUOKA",
      latitude: 33.5904,
      longitude: 130.4017,
      events: [{ date: "2026-11-22", title: "", url: "" }]
    }
  ];

  // 2026AW event schedule imported from GR_EVENT_26AW.xlsx.
  // Only locations with a confirmed venue and map position are rendered.
  const VENUES_DATA = [
    { venueId: "01", venueName: "SALOMON STORE SHIBUYA", area: "TOKYO", region: "kanto", latitude: 35.665131, longitude: 139.703186, events: [{ date: "2026-09-19", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000164" }] },
    { venueId: "02", venueName: "SALOMON STORE ABENO HOOP", area: "OSAKA", region: "kansai", latitude: 34.645473, longitude: 135.513748, events: [{ date: "2026-09-20", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000165" }] },
    { venueId: "03", venueName: "SALOMON STORE MARK IS MINATOMIRAI", area: "KANAGAWA", region: "kanto", latitude: 35.456959, longitude: 139.631927, events: [{ date: "2026-09-26", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000166" }] },
    { venueId: "04", venueName: "SUPER SPORTS XEBIO FUKUOKA TENJIN", area: "FUKUOKA", region: "kyushu", latitude: 33.586347, longitude: 130.403834, events: [{ date: "2026-09-26", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000167" }] },
    { venueId: "05", venueName: "OSHMANS FUTAKOTAMAGAWA", area: "TOKYO", region: "kanto", latitude: 35.611366, longitude: 139.628525, events: [{ date: "2026-09-26", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000168" }] },
    { venueId: "06", venueName: "SALOMON STORE LALAPORT EXPOCITY", area: "OSAKA", region: "kansai", latitude: 34.80739, longitude: 135.53128, events: [{ date: "2026-09-27", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000169" }] },
    { venueId: "07", venueName: "SALOMON STORE NEWMAN TAKANAWA", area: "TOKYO", region: "kanto", latitude: 35.63573, longitude: 139.74002, events: [{ date: "2026-10-03", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000184" }] },
    { venueId: "08", venueName: "SUPER SPORTS XEBIO ASUTO NAGAMACHI", area: "MIYAGI", region: "tohoku", latitude: 38.21438, longitude: 140.88346, events: [{ date: "2026-10-03", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000182" }] },
    { venueId: "09", venueName: "ISHII SPORTS YODOBASHI IKEBUKURO", area: "TOKYO", region: "kanto", latitude: 35.72923, longitude: 139.71008, events: [{ date: "2026-10-03", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000183" }] },
    { venueId: "10", venueName: "OSHMANS NAGOYA", area: "AICHI", region: "chubu", latitude: 35.17131, longitude: 136.88174, events: [{ date: "2026-10-04", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000185" }] },
    { venueId: "11", venueName: "SALOMON STORE KICHIJOJI", area: "TOKYO", region: "kanto", latitude: 35.70352, longitude: 139.57911, events: [{ date: "2026-10-10", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000186" }] },
    { venueId: "12", venueName: "SALOMON STORE ONE FUKUOKA BLDG.", area: "FUKUOKA", region: "kyushu", latitude: 33.58738, longitude: 130.39563, events: [{ date: "2026-10-17", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000190" }] },
    { venueId: "13", venueName: "SALOMON STORE KYOTO BAL", area: "KYOTO", region: "kansai", latitude: 35.00467, longitude: 135.76748, events: [{ date: "2026-10-17", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000189" }] },
    { venueId: "14", venueName: "MURASAKISPORTS anotherstyle", area: "KANAGAWA", region: "kanto", latitude: 35.3390107, longitude: 139.4649071, events: [{ date: "2026-10-17", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000188" }] },
    { venueId: "15", venueName: "ART SPORTS HONTEN", area: "TOKYO", region: "kanto", latitude: 35.706764, longitude: 139.773941, events: [{ date: "2026-10-17", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000187" }, { date: "2026-10-18", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000191" }] },
    { venueId: "16", venueName: "SALOMON GRAVEL RUNNING SESSION ART SPORTS LINKS UMEDA", area: "OSAKA", region: "kansai", latitude: 34.70417, longitude: 135.497269, events: [{ date: "2026-10-24", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000194" }] },
    { venueId: "17", venueName: "SALOMON STORE MINTO KOBE", area: "HYOGO", region: "kansai", latitude: 34.694664, longitude: 135.195938, events: [{ date: "2026-10-24", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000193" }] },
    { venueId: "18", venueName: "VICTORIA KOSHIGAYA LAKETOWN", area: "SAITAMA", region: "kanto", latitude: 35.87617, longitude: 139.78948, events: [{ date: "2026-10-24", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000192" }] },
    { venueId: "19", venueName: "SALOMON STORE LALAPORT TOKYO-BAY", area: "CHIBA", region: "kanto", latitude: 35.686241, longitude: 139.990204, events: [{ date: "2026-10-31", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000195" }] },
    { venueId: "20", venueName: "ALPEN RUN MEIJI PARK", area: "TOKYO", region: "kanto", latitude: 35.676704, longitude: 139.7134773, events: [{ date: "2026-11-01", title: "", url: "https://reg31.smp.ne.jp/regist/is?SMPFORM=qgtd-mbmfre-f2adc220521664b30c5a4cfee19999d5&list=1&event=MST0000000211" }] }
  ];

  window.GRVL_VENUES_DATA = VENUES_DATA;

  document.querySelectorAll("[data-grvl-map-stage]").forEach((stage) => {
  const map = stage.closest(".grvl-event-map");
  const clusterMode = map?.dataset.clusterMode || "dynamic";
  const mapShape = stage.querySelector("[data-grvl-map-shape]");
  const mapPath = stage.querySelector("[data-grvl-japan-path]");
  const interaction = stage.querySelector("[data-grvl-map-interaction]");
  const pinLayer = stage.querySelector("[data-grvl-pin-layer]");
  const resetButton = stage.querySelector("[data-grvl-map-reset]");
  const status = stage.querySelector("[data-grvl-map-status]");

  if (!stage || !mapShape || !mapPath || !interaction || !pinLayer || !window.d3 || !window.GRVL_JAPAN_MAP_DATA) {
    return;
  }

  const mapData = window.GRVL_JAPAN_MAP_DATA;
  const projection = d3.geoMercator()
    .scale(mapData.scale)
    .translate(mapData.translate);

  const venues = VENUES_DATA.map((venue) => {
    const point = projection([venue.longitude, venue.latitude]);
    return { ...venue, mapX: point[0], mapY: point[1] };
  });

  const initialCenterPoint = projection(INITIAL_CENTER);
  const initialTransform = d3.zoomIdentity
    .translate(VIEWBOX_WIDTH / 2, VIEWBOX_HEIGHT / 2)
    .scale(INITIAL_ZOOM)
    .translate(-initialCenterPoint[0], -initialCenterPoint[1]);

  let currentTransform = initialTransform;
  let activeVenueId = null;
  let expandedRegionalCluster = null;
  let isClusterZooming = false;
  let hoverCloseTimer = 0;
  let isPinching = false;
  let renderFrame = 0;

  mapPath.setAttribute("d", mapData.path);

  const zoom = d3.zoom()
    .scaleExtent([MIN_ZOOM, MAX_ZOOM])
    .extent([[0, 0], [VIEWBOX_WIDTH, VIEWBOX_HEIGHT]])
    .translateExtent([
      [-PAN_PADDING, -PAN_PADDING],
      [VIEWBOX_WIDTH + PAN_PADDING, VIEWBOX_HEIGHT + PAN_PADDING]
    ])
    .filter((event) => {
      if (event.type === "dblclick") return false;
      if (event.type === "mousedown" && event.button !== 0) return false;
      return true;
    })
    .on("start", (event) => {
      const source = event.sourceEvent;
      isPinching = Boolean(source && source.touches && source.touches.length > 1);
      if (source && (source.type === "touchmove" || source.type === "wheel")) {
        closeTooltip();
      }
    })
    .on("zoom", (event) => {
      currentTransform = event.transform;
      mapShape.setAttribute("transform", currentTransform.toString());
      if (event.sourceEvent && event.sourceEvent.touches && event.sourceEvent.touches.length > 1) {
        isPinching = true;
        closeTooltip();
      }
      scheduleRender();
    })
    .on("end", () => {
      isPinching = false;
      scheduleRender();
    });

  d3.select(interaction)
    .call(zoom)
    .call(zoom.transform, initialTransform);

  function getStageViewport() {
    const rect = stage.getBoundingClientRect();
    const scale = Math.min(rect.width / VIEWBOX_WIDTH, rect.height / VIEWBOX_HEIGHT);
    return {
      scale,
      offsetX: (rect.width - VIEWBOX_WIDTH * scale) / 2,
      offsetY: (rect.height - VIEWBOX_HEIGHT * scale) / 2
    };
  }

  function getScreenPoint(venue) {
    // SVG's default preserveAspectRatio="xMidYMid meet" can add letterboxing.
    // Apply the same scale and offset to the HTML PIN layer.
    const viewport = getStageViewport();
    return {
      x: viewport.offsetX + currentTransform.applyX(venue.mapX) * viewport.scale,
      y: viewport.offsetY + currentTransform.applyY(venue.mapY) * viewport.scale
    };
  }

  function clusterVenues(points) {
    const parents = points.map((_, index) => index);

    function root(index) {
      let current = index;
      while (parents[current] !== current) {
        parents[current] = parents[parents[current]];
        current = parents[current];
      }
      return current;
    }

    function join(a, b) {
      const rootA = root(a);
      const rootB = root(b);
      if (rootA !== rootB) parents[rootB] = rootA;
    }

    for (let a = 0; a < points.length; a += 1) {
      for (let b = a + 1; b < points.length; b += 1) {
        if (Math.hypot(points[a].x - points[b].x, points[a].y - points[b].y) <= CLUSTER_DISTANCE) {
          join(a, b);
        }
      }
    }

    const groups = new Map();
    points.forEach((point, index) => {
      const key = root(index);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(point);
    });
    return Array.from(groups.values());
  }

  // The comparison map locks the initial geographical groups. This makes the
  // initial appearance identical to the current map while giving every region
  // its own fit-to-pins zoom level after a cluster is selected.
  const regionalClusters = clusterMode === "regional"
    ? clusterVenues(venues.map((venue) => ({ venue, ...getScreenPoint(venue) })))
      .map((cluster, index) => ({ id: `regional-${index}`, venueIds: cluster.map((point) => point.venue.venueId) }))
    : [];

  function scheduleRender() {
    cancelAnimationFrame(renderFrame);
    renderFrame = requestAnimationFrame(updatePinPositions);
  }

  function updatePinPositions() {
    const points = venues.map((venue) => ({ venue, ...getScreenPoint(venue) }));
    if (clusterMode === "regional") {
      const pointsByVenueId = new Map(points.map((point) => [point.venue.venueId, point]));
      const openVenue = activeVenueId;
      const expandAllRegionalClusters = currentTransform.k >= MANUAL_REGIONAL_EXPAND_ZOOM;
      pinLayer.replaceChildren();

      regionalClusters.forEach((regionalCluster) => {
        const cluster = regionalCluster.venueIds.map((venueId) => pointsByVenueId.get(venueId));
        if (expandAllRegionalClusters || regionalCluster.id === expandedRegionalCluster || cluster.length === 1) {
          cluster.forEach((point) => renderVenuePin(point, openVenue === point.venue.venueId));
        } else {
          if (cluster.some((point) => point.venue.venueId === openVenue)) activeVenueId = null;
          renderClusterPin(cluster, regionalCluster.id);
        }
      });

      status.textContent = `REGIONAL CLUSTERS / ${regionalClusters.length} AREAS`;
      return;
    }

    const clusters = clusterVenues(points);
    const openVenue = activeVenueId;
    pinLayer.replaceChildren();

    clusters.forEach((cluster) => {
      if (cluster.length === 1) {
        renderVenuePin(cluster[0], openVenue === cluster[0].venue.venueId);
      } else {
        if (cluster.some((point) => point.venue.venueId === openVenue)) activeVenueId = null;
        renderClusterPin(cluster);
      }
    });

    status.textContent = `ZOOM ${currentTransform.k.toFixed(1)}× / ${clusters.length} LOCATIONS`;
  }

  function createWrap(x, y) {
    const wrap = document.createElement("div");
    wrap.className = "grvl-event-map__pin-wrap";
    wrap.style.transform = `translate(${x}px, ${y}px)`;
    return wrap;
  }

  function renderVenuePin(point, shouldOpen) {
    const wrap = createWrap(point.x, point.y);
    const pin = document.createElement("button");
    const tooltip = createTooltip(point.venue);
    const tooltipId = `grvl-tooltip-${point.venue.venueId}`;

    wrap.dataset.venueId = point.venue.venueId;
    pin.type = "button";
    pin.className = "grvl-event-map__pin";
    pin.setAttribute("aria-label", `${point.venue.area} ${point.venue.venueName}`);
    pin.setAttribute("aria-controls", tooltipId);
    pin.setAttribute("aria-expanded", String(shouldOpen));
    pin.innerHTML = `
      <span class="grvl-event-map__pin-dot" aria-hidden="true"></span>
      <span class="grvl-event-map__pin-ring" aria-hidden="true" style="--i: 0;"></span>
      <span class="grvl-event-map__pin-ring" aria-hidden="true" style="--i: 1;"></span>
      <span class="grvl-event-map__pin-ring" aria-hidden="true" style="--i: 2;"></span>`;
    tooltip.id = tooltipId;
    tooltip.dataset.open = String(shouldOpen);
    wrap.dataset.active = String(shouldOpen);

    pin.addEventListener("mouseenter", () => {
      if (!isClusterZooming && window.matchMedia("(hover: hover)").matches) openTooltip(point.venue.venueId);
    });
    pin.addEventListener("mouseleave", scheduleTooltipClose);
    pin.addEventListener("click", (event) => {
      event.stopPropagation();
      if (isPinching || isClusterZooming) return;
      if (window.matchMedia("(hover: hover)").matches) {
        openTooltip(point.venue.venueId);
      } else {
        activeVenueId === point.venue.venueId ? closeTooltip() : openTooltip(point.venue.venueId);
      }
    });
    tooltip.addEventListener("mouseenter", cancelTooltipClose);
    tooltip.addEventListener("mouseleave", scheduleTooltipClose);
    tooltip.addEventListener("click", (event) => event.stopPropagation());

    wrap.append(pin, tooltip);
    pinLayer.append(wrap);
    if (shouldOpen) requestAnimationFrame(() => positionTooltip(wrap, tooltip));
  }

  function renderClusterPin(cluster, regionalClusterId = null) {
    const x = d3.mean(cluster, (point) => point.x);
    const y = d3.mean(cluster, (point) => point.y);
    const wrap = createWrap(x, y);
    const button = document.createElement("button");

    button.type = "button";
    button.className = "grvl-event-map__cluster";
    button.innerHTML = `<span>${cluster.length}</span>`;
    button.setAttribute("aria-label", `${cluster.length}件の会場を拡大表示`);
    button.addEventListener("click", (event) => {
      event.stopPropagation();
      if (regionalClusterId) zoomIntoRegionalCluster(cluster, regionalClusterId);
      else zoomIntoCluster(cluster);
    });
    wrap.append(button);
    pinLayer.append(wrap);
  }

  function zoomIntoCluster(cluster) {
    closeTooltip();
    isClusterZooming = true;
    const centerX = d3.mean(cluster, (point) => point.venue.mapX);
    const centerY = d3.mean(cluster, (point) => point.venue.mapY);
    const viewport = getStageViewport();

    function clusterWillSplitAt(zoomLevel) {
      const simulatedPoints = cluster.map((point) => ({
        venue: point.venue,
        x: point.venue.mapX * zoomLevel * viewport.scale,
        y: point.venue.mapY * zoomLevel * viewport.scale
      }));
      return clusterVenues(simulatedPoints).length > 1;
    }

    // Increase until the actual clustering algorithm reports a split.
    // This accounts for chained groups where the farthest pair is already apart,
    // but intermediate venues still keep the whole cluster connected.
    let lowerZoom = currentTransform.k;
    let upperZoom = Math.min(MAX_ZOOM, currentTransform.k * 1.5);
    while (upperZoom < MAX_ZOOM && !clusterWillSplitAt(upperZoom)) {
      lowerZoom = upperZoom;
      upperZoom = Math.min(MAX_ZOOM, upperZoom * 1.75);
    }

    // Find the smallest zoom that genuinely reduces the clicked cluster.
    if (clusterWillSplitAt(upperZoom)) {
      for (let step = 0; step < 10; step += 1) {
        const midpoint = (lowerZoom + upperZoom) / 2;
        if (clusterWillSplitAt(midpoint)) {
          upperZoom = midpoint;
        } else {
          lowerZoom = midpoint;
        }
      }
    }

    // Small safety margin prevents rounding at responsive widths from rejoining it.
    const targetZoom = Math.min(MAX_ZOOM, upperZoom * 1.08);
    const target = d3.zoomIdentity
      .translate(VIEWBOX_WIDTH / 2, VIEWBOX_HEIGHT / 2)
      .scale(targetZoom)
      .translate(-centerX, -centerY);

    d3.select(interaction)
      .transition()
      .duration(window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 520)
      .ease(d3.easeCubicOut)
      .call(zoom.transform, target)
      .on("end", () => { isClusterZooming = false; });
  }

  function zoomIntoRegionalCluster(cluster, regionalClusterId) {
    closeTooltip();
    isClusterZooming = true;
    expandedRegionalCluster = regionalClusterId;
    const xValues = cluster.map((point) => point.venue.mapX);
    const yValues = cluster.map((point) => point.venue.mapY);
    const minX = d3.min(xValues);
    const maxX = d3.max(xValues);
    const minY = d3.min(yValues);
    const maxY = d3.max(yValues);
    const centerX = (minX + maxX) / 2;
    const centerY = (minY + maxY) / 2;
    const fitPadding = 140;
    const width = Math.max(maxX - minX, 1);
    const height = Math.max(maxY - minY, 1);
    const targetZoom = Math.min(
      MAX_ZOOM,
      (VIEWBOX_WIDTH - fitPadding * 2) / width,
      (VIEWBOX_HEIGHT - fitPadding * 2) / height
    );
    const target = d3.zoomIdentity
      .translate(VIEWBOX_WIDTH / 2, VIEWBOX_HEIGHT / 2)
      .scale(targetZoom)
      .translate(-centerX, -centerY);

    d3.select(interaction)
      .transition()
      .duration(window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 520)
      .ease(d3.easeCubicOut)
      .call(zoom.transform, target)
      .on("end", () => { isClusterZooming = false; });
  }

  function createTooltip(venue) {
    const tooltip = document.createElement("div");
    tooltip.className = "grvl-event-map__tooltip";
    tooltip.setAttribute("role", "dialog");
    tooltip.setAttribute("aria-label", `${venue.venueName}のイベント`);

    venue.events.forEach((event) => {
      const date = parseLocalDate(event.date);
      const item = document.createElement("article");
      item.className = "grvl-event-map__event";
      item.innerHTML = `
        <div class="grvl-event-map__date">
          <span class="grvl-event-map__month">${date.month}</span>
          <span class="grvl-event-map__day">${date.day}</span>
        </div>
        <div class="grvl-event-map__content">
          <p class="grvl-event-map__area">${escapeHtml(venue.area)}</p>
          <p class="grvl-event-map__venue">${escapeHtml(venue.venueName)}</p>
          ${event.url
            ? `<a class="grvl-event-map__details" href="${escapeHtml(event.url)}">VIEW DETAIL <span aria-hidden="true">→</span></a>`
            : '<span class="grvl-event-map__coming">Coming soon</span>'}
        </div>`;
      tooltip.append(item);
    });
    return tooltip;
  }

  function parseLocalDate(value) {
    const [year, month, day] = value.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    return {
      month: new Intl.DateTimeFormat("en-US", { month: "short" }).format(date).toUpperCase(),
      day: String(day).padStart(2, "0")
    };
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function openTooltip(venueId) {
    cancelTooltipClose();
    activeVenueId = venueId;
    pinLayer.querySelectorAll("[data-venue-id]").forEach((wrap) => {
      const isActive = wrap.dataset.venueId === venueId;
      const pin = wrap.querySelector(".grvl-event-map__pin");
      const tooltip = wrap.querySelector(".grvl-event-map__tooltip");
      wrap.dataset.active = String(isActive);
      pin?.setAttribute("aria-expanded", String(isActive));
      if (tooltip) tooltip.dataset.open = String(isActive);
      if (isActive && tooltip) requestAnimationFrame(() => positionTooltip(wrap, tooltip));
    });
  }

  function closeTooltip() {
    cancelTooltipClose();
    if (!activeVenueId) return;
    activeVenueId = null;
    pinLayer.querySelectorAll("[data-venue-id]").forEach((wrap) => {
      wrap.dataset.active = "false";
      wrap.querySelector(".grvl-event-map__pin")?.setAttribute("aria-expanded", "false");
      const tooltip = wrap.querySelector(".grvl-event-map__tooltip");
      if (tooltip) tooltip.dataset.open = "false";
    });
  }

  function scheduleTooltipClose() {
    if (!window.matchMedia("(hover: hover)").matches) return;
    cancelTooltipClose();
    hoverCloseTimer = window.setTimeout(closeTooltip, HOVER_CLOSE_DELAY);
  }

  function cancelTooltipClose() {
    window.clearTimeout(hoverCloseTimer);
  }

  function positionTooltip(wrap, tooltip) {
    if (tooltip.dataset.open !== "true") return;
    const stageRect = stage.getBoundingClientRect();
    const pinRect = wrap.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const pinX = pinRect.left - stageRect.left;
    const pinY = pinRect.top - stageRect.top;
    let left = -tooltipRect.width / 2;
    let top = -tooltipRect.height - TOOLTIP_GAP;

    const absoluteLeft = pinX + left;
    const absoluteRight = absoluteLeft + tooltipRect.width;
    if (absoluteLeft < TOOLTIP_EDGE) left += TOOLTIP_EDGE - absoluteLeft;
    if (absoluteRight > stageRect.width - TOOLTIP_EDGE) left -= absoluteRight - (stageRect.width - TOOLTIP_EDGE);
    if (pinY + top < TOOLTIP_EDGE) top = TOOLTIP_GAP;

    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;
  }

  function resetMap() {
    closeTooltip();
    expandedRegionalCluster = null;
    d3.select(interaction)
      .transition()
      .duration(window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 480)
      .ease(d3.easeCubicOut)
      .call(zoom.transform, initialTransform);
  }

  resetButton.addEventListener("click", resetMap);
  interaction.addEventListener("click", closeTooltip);
  stage.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeTooltip();
  });

  const resizeObserver = new ResizeObserver(scheduleRender);
  resizeObserver.observe(stage);

  updatePinPositions();
  requestAnimationFrame(() => requestAnimationFrame(updatePinPositions));
  window.addEventListener("load", updatePinPositions, { once: true });
  });
})();
